import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import Dashboard from "../components/MerchantDashboard";
import CustomHelmet from "../components/CustomHelmet";
import ListingContainer from "../components/ListingContainer";
import axios from "axios";
import { Link } from "react-router-dom";

const url =
  "https://www.hubsquares.com/php_files/fetchListingOwner.php/";

const MyListing = ({ user }) => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(false);
  useEffect(() => {
    const fetchListing = async () => {
      await axios.post(url, { owner: user }).then((res) => {
        setListings(res.data.listing);
        if (!res.data.listing) setEmpty(true);
        setLoading(false);
      });
    };
    fetchListing();
  }, [user]);

  return (
    <>
      <CustomHelmet page="My Business" />
      <Dashboard user={user} page="My Business">
        <Container className="my-3">
          {loading ? (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          ) : (
            listings &&
            listings.map((list) => (
              <div key={list.refID} className="my-2">
                <ListingContainer
                  title={list.title}
                  location={list.state}
                  business={list.refID}
                  status={list.status}
                />
              </div>
            ))
          )}
          {empty ? (
            <div>
              <h5>You have no business</h5>
              <Link className="nav-link" to="/packages">
                <button className="btn btn-danger btn-lg addbtn">
                  <i className="fa fa-plus p-0" /> <span>Add Business</span>
                </button>
              </Link>
            </div>
          ) : null}
        </Container>
      </Dashboard>
    </>
  );
};
export default MyListing;
